// extracted by mini-css-extract-plugin
export default {"label":"styles_label__TL6IL","input":"styles_input__oYK2B","editButton":"styles_editButton__xr4V8","closeButton":"styles_closeButton__HVM3C","button":"styles_button__wEIyC"};